module.exports = __webpack_public_path__ + "static/media/finallogo.70867491.png";